import React from "react";
import PropTypes from "prop-types";

import Modal from "Util/Modal";

import { OrderObject } from "./../Queries/OrderQuery";

import Table from "./Table";
import invoiceLinesUpdater from "./ReverseInvoiceLinesUpdater";

import ReverseInvoices from "./ReverseInvoices";

class ReverseInvoicePopup extends React.Component {
  render() {
    const { order, invoiceLines } = this.props;
    return (
      <Modal
        show={true}
        header="Reverse Invoice"
        onClose={this.props.close}
        className="invoiceable-lines"
      >
        <div>
          <h2>CMP Order #: {order.cmpOrderNumber}</h2>
          <p className="invoiceable-lines-message">
            The following lines are ready for invoicing and can be reversed
          </p>
          <Table
            order={order}
            invoiceLines={invoiceLines}
            close={this.props.close}
            showPartnerRef={false}
            invoiceLinesUpdater={invoiceLinesUpdater}
            processComponent={ReverseInvoices}
          />
        </div>
      </Modal>
    );
  }
}

ReverseInvoicePopup.propTypes = {
  order: OrderObject,
  invoiceLines: PropTypes.array.isRequired,
  close: PropTypes.func.isRequired
};

export default ReverseInvoicePopup;
